/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsItemsProductsCtrl
 * @description A report with sales grouped by Pos Item
 */
angular.module('mercury.modules.reports.items')
.controller('ReportsItemsProductsCtrl', ["$filter", "ReportPosItems", "ReportPosStaff", "reporttime", "$scope", "$stateParams", "title", "$q", function($filter, ReportPosItems, ReportPosStaff, reporttime, $scope, $stateParams, title, $q) {
  $scope.productCols = [
    {label: 'Product', type: 'string', key: 'itemName'},
    {label: 'Orders', type: 'number', key: 'orderAmount', filter: 'currency'}
  ];

  $scope.itemsOptions = {
    sliceVisibilityThreshold: 0.000025
  };

  if ($stateParams.categoryId) {
    $scope.loading = $q.all({
      sales: ReportPosItems.getSales(reporttime.start(), reporttime.end(), $stateParams.categoryId),
      orders: ReportPosItems.getOrders(reporttime.start(), reporttime.end(), $stateParams.categoryId)
    });
    title.set($stateParams.categoryName + ' Category Report');
  } else if ($stateParams.staffId && $stateParams.staffName) {
    $scope.loading = $q.all({
      sales: ReportPosStaff.getItemSalesForStaff(reporttime.start(), reporttime.end(), $stateParams.staffId),
      orders: ReportPosStaff.getItemOrdersForStaff(reporttime.start(), reporttime.end(), $stateParams.staffId)
    });
    title.set('Products Report for ' + $stateParams.staffName);
  } else {
    $scope.loading = $q.all({
      sales: ReportPosItems.getSales(reporttime.start(), reporttime.end()),
      orders: ReportPosItems.getOrders(reporttime.start(), reporttime.end())
    });
    title.set('Products Report');
  }

  $scope.loading.then(function(results) {
    var combinedSalesAndOrders = {};

    angular.forEach(results.sales, function(sale) {
      combinedSalesAndOrders[sale.itemPosIdentifier] = sale;
      combinedSalesAndOrders[sale.itemPosIdentifier].orderAmount = 0;
      combinedSalesAndOrders[sale.itemPosIdentifier].orderQty = 0;
    });

    angular.forEach(results.orders, function(order) {
      existingRecord = combinedSalesAndOrders[order.itemPosIdentifier];
      if (existingRecord) {
        existingRecord.orderAmount = order.amount;
        existingRecord.orderQty = order.quantity;
      } else { //It is possible that an item was ordered, but not sold in the report period
        combinedSalesAndOrders[order.itemPosIdentifier] = {
          itemPosIdentifier: order.itemPosIdentifier,
          orderAmount: order.amount,
          orderQty: order.quantity,
          itemName: order.itemName,
          invoices: 0,
          quantity: 0
        };
      }
    });

    $scope.productSales = Object.values(combinedSalesAndOrders);
    $scope.total = $filter('sumof')($scope.productSales, 'invoices');
    $scope.totalCount = $filter('sumof')($scope.productSales, 'quantity');
    $scope.totalOrders = $filter('sumof')($scope.productSales, 'orderAmount');
    $scope.orderQty = $filter('sumof')($scope.productSales, 'orderQty');
  });
}]);
